module.exports = __webpack_public_path__ + "img/icon_4_35.b81ca0af.png";